var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoPp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PP logomark"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 5826"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.7936 14.1733V23.5232H29.7659C28.1351 23.5199 26.5318 23.9467 25.1162 24.7611V14.1733H29.7936Z",
    fill: "#4D91A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.0582 23.5845H20.3809V64.8366H25.0582V23.5845Z",
    fill: "#84C4C9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20.3449 32.9927H15.6675V60.1297H20.3449V32.9927Z",
    fill: "#D2ECE9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M39.1985 28.3499V23.6458C41.0624 23.6485 42.8853 23.095 44.4362 22.0552C45.9872 21.0155 47.1965 19.5363 47.9111 17.8049C48.6256 16.0735 48.8133 14.1678 48.4503 12.3291C48.0874 10.4903 47.1901 8.80126 45.8721 7.47571C44.5541 6.15016 42.8746 5.24773 41.0463 4.88269C39.218 4.51764 37.3232 4.70639 35.6016 5.42505C33.8801 6.1437 32.4093 7.35994 31.3754 8.91977C30.3416 10.4796 29.7912 12.3129 29.7939 14.1875H25.1138C25.1138 11.3815 25.9411 8.63846 27.4912 6.30534C29.0413 3.97222 31.2445 2.15378 33.8221 1.07996C36.3998 0.00614717 39.2362 -0.274812 41.9727 0.272615C44.7091 0.820042 47.2227 2.17127 49.1956 4.15542C51.1685 6.13958 52.512 8.66754 53.0563 11.4196C53.6007 14.1717 53.3213 17.0244 52.2536 19.6168C51.1859 22.2092 49.3778 24.425 47.0579 25.9839C44.7381 27.5429 42.0106 28.375 39.2206 28.375L39.1985 28.3499Z",
    fill: "#4D91A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M29.7939 23.5235V69.541H25.1138V24.7531C26.5294 23.9387 28.1326 23.5119 29.7635 23.5152L29.7939 23.5235Z",
    fill: "#4D91A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M43.859 32.9927C43.859 36.7487 42.3781 40.3514 39.7409 43.011C37.1037 45.6705 33.5255 47.1698 29.7909 47.1801V42.4649C32.2884 42.4649 34.6837 41.4671 36.4497 39.6909C38.2157 37.9148 39.2079 35.5059 39.2079 32.994C39.2079 30.4822 38.2157 28.0733 36.4497 26.2971C34.6837 24.521 32.2884 23.5232 29.7909 23.5232H29.7632C28.1324 23.5199 26.5292 23.9468 25.1135 24.7611L25.0582 24.7917C23.7478 25.5571 22.6395 26.6281 21.8269 27.9145C21.0144 29.2009 20.5212 30.6649 20.3891 32.1831C20.367 32.4502 20.3559 32.72 20.3559 32.9927H15.6675C15.6675 29.2299 17.1537 25.6213 19.7993 22.9606C22.4448 20.2999 26.0329 18.8052 29.7743 18.8052H29.7937C33.5283 18.8155 37.1065 20.3148 39.7437 22.9743C42.3808 25.6339 43.8618 29.2366 43.8617 32.9927H43.859Z",
    fill: "#D2ECE9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPp);
export default __webpack_public_path__ + "static/media/logoPP.02ded49f308017a70d8c40f11d707a1d.svg";
export { ForwardRef as ReactComponent };